(function () {
  'use strict';

  var productWrapper, mediaWrapper, infoWrapper, col3;

  function applyThreeCol() {
    var marker = document.querySelector('[data-product-col-break]');
    if (!marker) return;

    var markerBlock = marker.closest('.product__block');
    if (!markerBlock) return;

    infoWrapper = markerBlock.closest('.product__info-wrapper');
    productWrapper = infoWrapper && infoWrapper.parentElement;
    if (!infoWrapper || !productWrapper) return;

    if (productWrapper.classList.contains('product--three-col')) return;

    mediaWrapper = productWrapper.querySelector(':scope > .product__media-wrapper');

    col3 = document.createElement('div');
    col3.className = 'product__info-wrapper product__info-col3';

    var col3Blocks = document.createElement('div');
    col3Blocks.className = 'product__blocks accordion-parent';
    col3.appendChild(col3Blocks);

    var sibling = markerBlock.nextElementSibling;
    while (sibling) {
      var next = sibling.nextElementSibling;
      col3Blocks.appendChild(sibling);
      sibling = next;
    }

    markerBlock.remove();
    infoWrapper.insertAdjacentElement('afterend', col3);
    productWrapper.classList.add('product--three-col');

    updateLayout();
    window.addEventListener('resize', updateLayout);
  }

  function setGrid(cols, gap) {
    productWrapper.style.setProperty('display', 'grid', 'important');
    productWrapper.style.setProperty('grid-template-columns', cols, 'important');
    productWrapper.style.setProperty('gap', gap, 'important');
    productWrapper.style.setProperty('align-items', 'start', 'important');
    productWrapper.style.setProperty('flex-wrap', 'nowrap', 'important');

    [mediaWrapper, infoWrapper, col3].forEach(function (el) {
      if (!el) return;
      el.style.setProperty('width', 'auto', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('min-width', '0', 'important');
      el.style.setProperty('float', 'none', 'important');
    });
  }

  function resetGrid() {
    ['display', 'grid-template-columns', 'gap', 'align-items', 'flex-wrap'].forEach(function (prop) {
      productWrapper.style.removeProperty(prop);
    });
    [mediaWrapper, infoWrapper, col3].forEach(function (el) {
      if (!el) return;
      ['width', 'max-width', 'min-width', 'float', 'grid-column'].forEach(function (prop) {
        el.style.removeProperty(prop);
      });
    });
  }

  function updateLayout() {
    if (!productWrapper) return;
    var w = window.innerWidth;
    if (w >= 990) {
      setGrid('minmax(0,1fr) minmax(0,1.3fr) minmax(0,1fr)', '2.5rem');
      if (mediaWrapper) mediaWrapper.style.removeProperty('grid-column');
    } else if (w >= 750) {
      setGrid('1fr 1fr', '1.5rem');
      if (mediaWrapper) mediaWrapper.style.setProperty('grid-column', '1 / -1', 'important');
    } else {
      resetGrid();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyThreeCol);
  } else {
    applyThreeCol();
  }

  document.addEventListener('shopify:section:load', function () {
    productWrapper = mediaWrapper = infoWrapper = col3 = null;
    window.removeEventListener('resize', updateLayout);
    applyThreeCol();
  });
})();
